import { render, staticRenderFns } from "./item4.vue?vue&type=template&id=16a6e526&scoped=true"
import script from "./item4.vue?vue&type=script&lang=js"
export * from "./item4.vue?vue&type=script&lang=js"
import style0 from "./item4.vue?vue&type=style&index=0&id=16a6e526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a6e526",
  null
  
)

export default component.exports